/* Progressive, native-scroll ingredient selector. No carousel dependency or timer. */
(() => {
'use strict';
function init(){
 const track=document.querySelector('.fw-ingredient-track');
 if(!track)return;
 const cards=[...track.querySelectorAll('.fw-ingredient-card')];
 // Warm the small local photo set as the section approaches the viewport.
 // This keeps a distant ingredient selection from revealing an empty photo.
 const loadPhotos=()=>cards.forEach(card=>{const photo=card.querySelector('img');if(photo)photo.loading='eager';});
 if('IntersectionObserver' in window){const photoObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){loadPhotos();photoObserver.disconnect();}},{rootMargin:'500px'});photoObserver.observe(track);}else loadPhotos();
 const tabs=[...document.querySelectorAll('[data-ingredient]')];
 const previous=document.querySelector('[data-slide="-1"]');
 const next=document.querySelector('[data-slide="1"]');
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 let active=0,frame=0,programmatic=false,endTimer;
 const left=i=>cards[i].offsetLeft-cards[0].offsetLeft;
 function paint(index){
  active=Math.max(0,Math.min(cards.length-1,index));
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-pressed',String(i===active));});
  cards.forEach((card,i)=>card.classList.toggle('is-active',i===active));
  previous.disabled=track.scrollLeft<2;
  next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
 }
 function go(index){
  index=Math.max(0,Math.min(cards.length-1,index));
  programmatic=true;paint(index);
  track.scrollTo({left:left(index),behavior:reduce.matches?'instant':'smooth'});
  const tab=tabs[index],row=tab.parentElement;
  row.scrollTo({left:Math.max(0,tab.offsetLeft-row.offsetLeft-(row.clientWidth-tab.offsetWidth)/2),behavior:reduce.matches?'instant':'smooth'});
  clearTimeout(endTimer);endTimer=setTimeout(()=>{programmatic=false;paint(index)},700);
 }
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>go(i));tab.addEventListener('keydown',e=>{let target=i;if(e.key==='ArrowRight')target=i+1;else if(e.key==='ArrowLeft')target=i-1;else if(e.key==='Home')target=0;else if(e.key==='End')target=cards.length-1;else return;e.preventDefault();target=Math.max(0,Math.min(cards.length-1,target));tabs[target].focus({preventScroll:true});go(target);});});
 previous.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
 track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(active+(e.key==='ArrowRight'?1:-1));}});
 const manual=()=>{programmatic=false;clearTimeout(endTimer)};
 track.addEventListener('pointerdown',manual,{passive:true});track.addEventListener('wheel',manual,{passive:true});track.addEventListener('touchstart',manual,{passive:true});
 track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{if(programmatic){previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;return;}const target=cards.reduce((best,card,i)=>Math.abs(left(i)-track.scrollLeft)<Math.abs(left(best)-track.scrollLeft)?i:best,0);paint(target);});},{passive:true});
 new ResizeObserver(()=>paint(active)).observe(track);paint(0);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
